import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router";

function TermsAndCondition() {
  const navigate = useNavigate();
  return (
    <div className="signup-container">
      <div className="signup-box" style={{ maxWidth: "900px", width: "100%" }}>
        <section>
          <div className="compliance-main-div">
            {/* Heading */}
            <div className="compliance-heading-div">
              <h1>Terms & Conditions</h1>
              <p>
                Please read these Terms and Conditions carefully before using
                our platform. By accessing or using our website, services, or
                applications, you agree to comply with and be bound by these
                terms.
              </p>
            </div>

            {/* Section 1 */}
            <div className="compliance-section">
              <h2>1. Acceptance of Terms</h2>
              <ul>
                <li>
                  By registering or accessing our platform, you agree to these
                  Terms and Conditions in full.
                </li>
                <li>
                  If you disagree with any part of the terms, you must not use
                  the platform.
                </li>
                <li>
                  We reserve the right to modify these terms at any time.
                  Updates will be posted on this page.
                </li>
              </ul>
            </div>

            {/* Section 2 */}
            <div className="compliance-section">
              <h2>2. User Responsibilities</h2>
              <ul>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your account and password.
                </li>
                <li>
                  You agree not to use the platform for any illegal, fraudulent,
                  or unauthorized activities.
                </li>
                <li>
                  You must provide accurate and up-to-date information during
                  registration and while using the services.
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div className="compliance-section">
              <h2>3. Intellectual Property Rights</h2>
              <ul>
                <li>
                  All logos, graphics, and content on this platform are the
                  property of Final Round or its licensors.
                </li>
                <li>
                  You may not copy, reproduce, or distribute any material
                  without prior written consent.
                </li>
                <li>
                  Unauthorized use of our intellectual property may lead to
                  legal action.
                </li>
              </ul>
            </div>

            {/* Section 4 */}
            <div className="compliance-section">
              <h2>4. Payments & Refunds</h2>
              <ul>
                <li>
                  All transactions are final and non-refundable unless stated
                  otherwise.
                </li>
                <li>
                  Users are responsible for any fees associated with payment
                  processing.
                </li>
                <li>
                  Refunds, if applicable, will be processed according to our
                  Refund Policy.
                </li>
              </ul>
            </div>

            {/* Section 5 */}
            <div className="compliance-section">
              <h2>5. Termination of Account</h2>
              <ul>
                <li>
                  We reserve the right to suspend or terminate accounts that
                  violate our terms or engage in misconduct.
                </li>
                <li>
                  Upon termination, your right to access the platform will cease
                  immediately.
                </li>
                <li>
                  Any unpaid balances must be settled before account closure.
                </li>
              </ul>
            </div>

            {/* Section 6 */}
            <div className="compliance-section">
              <h2>6. Limitation of Liability</h2>
              <ul>
                <li>
                  We are not responsible for any indirect, incidental, or
                  consequential damages resulting from the use of our services.
                </li>
                <li>
                  The platform is provided “as is” without any guarantees of
                  accuracy or reliability.
                </li>
                <li>
                  Users assume full responsibility for any risks associated with
                  using the platform.
                </li>
              </ul>
            </div>

            {/* Section 7 */}
            <div className="compliance-section">
              <h2>7. Governing Law</h2>
              <ul>
                <li>
                  These Terms and Conditions shall be governed by and
                  interpreted in accordance with the laws of your jurisdiction.
                </li>
                <li>
                  Any disputes shall be resolved in the competent courts within
                  the same jurisdiction.
                </li>
              </ul>
            </div>

            {/* Section 8 */}
            <div className="compliance-section">
              <h2>8. Contact Information</h2>
              <ul>
                <li>
                  For questions or concerns about these Terms and Conditions,
                  please contact us at{" "}
                  <a href="mailto:support@finalround.com">
                    support@finalround.com
                  </a>
                  .
                </li>
              </ul>
            </div>
            <Button onClick={() => navigate(-1)}>Back to page</Button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TermsAndCondition;
